/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-cell.component';
const styles_DataTableBodyCellComponent:any[] = ([] as any[]);
export const RenderType_DataTableBodyCellComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableBodyCellComponent,data:{}});
function View_DataTableBodyCellComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'label',[['class',
      'datatable-checkbox']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),0,'input',[['type','checkbox']],[[8,'checked',0]],
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onCheckboxChange($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.isSelected;
        _ck(_v,2,0,currVal_0);
      });
}
function View_DataTableBodyCellComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      [[8,'title',0],[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.value;
        const currVal_1:any = _co.value;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_DataTableBodyCellComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(null as any));
}
function View_DataTableBodyCellComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,[[1,3],['cellTemplate',2]],(null as any),
      2,(null as any),View_DataTableBodyCellComponent_4)),i0.ɵdid(540672,(null as any),
      0,i1.NgTemplateOutlet,[i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet'],
          ngOutletContext:[1,'ngOutletContext']},(null as any)),i0.ɵpod({value:0,row:1,
      column:2,isSelected:3,onCheckboxChangeFn:4,activateFn:5}),(_l()(),i0.ɵand(0,
      (null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.column.cellTemplate;
    const currVal_1:any = _ck(_v,2,0,_co.value,_co.row,_co.column,_co.isSelected,_co.onCheckboxChangeFn,
        _co.activateFn);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_DataTableBodyCellComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{cellTemplate:0}),(_l()(),i0.ɵted((null as any),
      ['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),10,'div',[['class',
      'datatable-body-cell-label']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableBodyCellComponent_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableBodyCellComponent_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableBodyCellComponent_3)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.DataTableBodyCellComponent = _v.component;
    const currVal_0:any = _co.column.checkboxable;
    _ck(_v,5,0,currVal_0);
    const currVal_1:boolean = !_co.column.cellTemplate;
    _ck(_v,8,0,currVal_1);
    const currVal_2:any = _co.column.cellTemplate;
    _ck(_v,11,0,currVal_2);
  },(null as any));
}
export function View_DataTableBodyCellComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-body-cell',
      [['class','datatable-body-cell']],[[8,'className',0],[4,'width','px'],[4,'height',
          (null as any)]],[[(null as any),'focus'],[(null as any),'blur'],[(null as any),
          'click'],[(null as any),'dblclick'],[(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onClick($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('dblclick' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1).onDblClick($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('keydown' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,1).onKeyDown($event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },View_DataTableBodyCellComponent_0,RenderType_DataTableBodyCellComponent)),
      i0.ɵdid(180224,(null as any),0,i2.DataTableBodyCellComponent,[i0.ElementRef],
          (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).columnCssClasses;
    const currVal_1:any = i0.ɵnov(_v,1).width;
    const currVal_2:any = i0.ɵnov(_v,1).height;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const DataTableBodyCellComponentNgFactory:i0.ComponentFactory<i2.DataTableBodyCellComponent> = i0.ɵccf('datatable-body-cell',
    i2.DataTableBodyCellComponent,View_DataTableBodyCellComponent_Host_0,{row:'row',
        column:'column',rowHeight:'rowHeight',isSelected:'isSelected',sorts:'sorts'},
    {activate:'activate'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./aot_output/~/@swimlane/ngx-datatable/release/components/body/body-cell.component.ngfactory.ts